import { render, staticRenderFns } from "./ShipBluTd.vue?vue&type=template&id=62ad4588"
import script from "./ShipBluTd.vue?vue&type=script&lang=js"
export * from "./ShipBluTd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports